document.addEventListener('DOMContentLoaded', () => {
  const deliveryText = document.querySelector('[data-fast-delivery-cities]');
  if (!deliveryText) return;

  const fastDeliveryCities = deliveryText.dataset.fastDeliveryCities
    .split(',')
    .map((city) => city.trim().toLowerCase())
    .filter(Boolean);

  if (!fastDeliveryCities.length) return;

  const fastDeliveryText = deliveryText.dataset.fastDeliveryText;

  // this is the fallback shown whenever fast delivery isn't active.
  const defaultDeliveryText = deliveryText.textContent;

  const INVENTORY_CHECK_URL = '/apps/inventory-check';
  const REVERSE_GEOCODE_URL = 'https://api.bigdatacloud.net/data/reverse-geocode-client';
  const PINCODE_CITY_LOOKUP_URL = 'https://api.postalpincode.in/pincode';
  const PINCODE_INPUT_DEBOUNCE_MS = 400;

  let currentVariantId = deliveryText.dataset.currentVariantId;
  let requestToken = 0;
  let clickpostObserver = null;
  let hasLocationPermission = false;
  let isGeoFastDeliveryCity = false;
  let activePincode = '';
  let lastResolvedPincode = '';
  let isPincodeFastDeliveryCity = false;

  const isAvailableAtDarkstore = async (variantId) => {
    try {
      const url = `${INVENTORY_CHECK_URL}?variant_id=${encodeURIComponent(variantId)}`;
      const response = await fetch(url);
      if (!response.ok) return false;

      const { available } = await response.json();
      return available === true;
    } catch {
      // Inventory check unavailable — treat as not stocked at the darkstore.
      return false;
    }
  };

  const overwriteClickpostResponseWith = (text) => {
    const clickpostEdd = document.getElementById('response-edd');
    if (clickpostEdd && clickpostEdd.textContent !== text) {
      clickpostEdd.textContent = text;
    }
  };


  const syncClickpostResponseWith = (text) => {
    const clickpostContainer = document.getElementById('clickpost-edd-section');
    if (!clickpostContainer) return;

    overwriteClickpostResponseWith(text);

    clickpostObserver?.disconnect();
    clickpostObserver = new MutationObserver(() => overwriteClickpostResponseWith(text));
    clickpostObserver.observe(clickpostContainer, { childList: true, subtree: true, characterData: true });
  };

  const setDisplayText = (text) => {
    deliveryText.textContent = text;
    syncClickpostResponseWith(text);
  };


  const refreshDisplayForVariant = async (variantId) => {
    const thisRequest = ++requestToken;

    const isFastCityActive =
      hasLocationPermission && (activePincode ? isPincodeFastDeliveryCity : isGeoFastDeliveryCity);

    if (!isFastCityActive) {
      if (thisRequest !== requestToken || variantId !== currentVariantId) return;
      setDisplayText(defaultDeliveryText);
      return;
    }

    const available = await isAvailableAtDarkstore(variantId);

    if (thisRequest !== requestToken || variantId !== currentVariantId) return;

    setDisplayText(available ? fastDeliveryText : defaultDeliveryText);
  };

  const checkGeoFastDeliveryCity = async ({ coords }) => {
    try {
      const url = `${REVERSE_GEOCODE_URL}?latitude=${coords.latitude}&longitude=${coords.longitude}&localityLanguage=en`;
      const response = await fetch(url);
      if (!response.ok) return;

      const { city } = await response.json();
      isGeoFastDeliveryCity = fastDeliveryCities.includes(city?.toLowerCase());
      refreshDisplayForVariant(currentVariantId);
    } catch {
      // Reverse geocoding unavailable — leave the default text as-is.
    }
  };

  const handleGeolocationGranted = (position) => {
    hasLocationPermission = true;
    checkGeoFastDeliveryCity(position);
  };

  if ('geolocation' in navigator) {
    navigator.geolocation.getCurrentPosition(handleGeolocationGranted, () => {});
  }

  const resolveCityFromPincode = async (pincode) => {
    try {
      const response = await fetch(`${PINCODE_CITY_LOOKUP_URL}/${pincode}`);
      if (!response.ok) return null;

      const [result] = await response.json();
      if (result?.Status !== 'Success' || !result.PostOffice?.length) return null;

      return result.PostOffice[0].District ?? null;
    } catch {
      // Pincode lookup unavailable — treat as not resolvable.
      return null;
    }
  };

  const handlePincodeEntry = async (pincode) => {
    activePincode = pincode;

    if (pincode === lastResolvedPincode) {
      refreshDisplayForVariant(currentVariantId);
      return;
    }
    lastResolvedPincode = pincode;

    const city = await resolveCityFromPincode(pincode);

    if (pincode !== activePincode) return;

    isPincodeFastDeliveryCity = fastDeliveryCities.includes(city?.toLowerCase());
    refreshDisplayForVariant(currentVariantId);
  };

  const handlePincodeCleared = () => {
    activePincode = '';
    refreshDisplayForVariant(currentVariantId);
  };

  const attachPincodeInputListener = (clickpostContainer) => {
    const pincodeInput = clickpostContainer.querySelector('.clickpost-edd__drop_pincode-input');
    if (!pincodeInput) return false;

    let pincodeDebounceTimer = null;

    pincodeInput.addEventListener('input', () => {
      const pincode = pincodeInput.value.trim();

      clearTimeout(pincodeDebounceTimer);

      if (!pincode) {
        handlePincodeCleared();
        return;
      }

      if (!/^\d{6}$/.test(pincode)) return;

      pincodeDebounceTimer = setTimeout(() => handlePincodeEntry(pincode), PINCODE_INPUT_DEBOUNCE_MS);
    });

    return true;
  };

  const watchForPincodeInput = () => {
    const clickpostContainer = document.getElementById('clickpost-edd-section');
    if (!clickpostContainer) return;

    if (attachPincodeInputListener(clickpostContainer)) return;


    const observer = new MutationObserver(() => {
      if (attachPincodeInputListener(clickpostContainer)) observer.disconnect();
    });
    observer.observe(clickpostContainer, { childList: true, subtree: true });
  };

  watchForPincodeInput();

  document.addEventListener('variant:changed', (event) => {
    const { variant } = event.detail || {};
    if (!variant) return;

    currentVariantId = String(variant.id);
    refreshDisplayForVariant(currentVariantId);
  });
});
